import { render, staticRenderFns } from "./ProductVariantSelector.vue?vue&type=template&id=1eed876e&scoped=true"
import script from "./ProductVariantSelector.vue?vue&type=script&lang=js"
export * from "./ProductVariantSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eed876e",
  null
  
)

export default component.exports